import { render, staticRenderFns } from "./ShowDiscrepancyPopup.vue?vue&type=template&id=52f5a403"
import script from "./ShowDiscrepancyPopup.vue?vue&type=script&lang=js"
export * from "./ShowDiscrepancyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports